module.exports = __webpack_public_path__ + "static/media/card-logo-amex.1f900269.svg";